module.exports = __webpack_public_path__ + "img/guitarra-1.f7000a57.jpg";